import {LayoutModule} from '@angular/cdk/layout';
import {CommonModule} from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  NgModule,
  Output
} from '@angular/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {Store} from '@ngrx/store';
import {DxButtonModule} from 'devextreme-angular';
import {DxLoadIndicatorModule} from 'devextreme-angular';
import {DxLoadPanelModule} from 'devextreme-angular';
import {DxPopupModule} from 'devextreme-angular';
import {DxScrollViewModule} from 'devextreme-angular';
import {DxTextBoxModule} from 'devextreme-angular';
import {DxToolbarModule} from 'devextreme-angular';
import {DxValidatorModule} from 'devextreme-angular';
import {DxSwitchModule} from 'devextreme-angular';
import {LogOut} from 'src/app/stores/actions/fusion-auth.actions';
import {AppState} from 'src/app/stores/app.state';
import {AppInfoService, ScreenService} from '../../../services/general';
import {UserProfileComponent} from '../../ocl';
import {UserPanelModule} from "../user-panel/user-panel.component";
import {TopNavigationMenuComponent} from "../top-navigation-menu/top-navigation-menu.component";
import {DxContextMenuModule} from "devextreme-angular";
import {ThemeToggleComponent} from "../theme-toggle/theme-toggle.component";

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Output()
  public menuToggle = new EventEmitter<boolean>();
  public userProfilePopup = false;

  @Input()
  public menuToggleEnabled = false;

  public userMenuItems = [
    {
      text: 'Profile',
      icon: 'user',
      onClick: () => {
        this.userProfilePopup = true;
      },
    },
    {
      text: 'Logout',
      icon: 'runner',
      onClick: () => {
        this.store.dispatch(new LogOut());
      },
    },
  ];

  constructor(
    public screen: ScreenService,
    private store: Store<AppState>,
    public appInfo: AppInfoService
  ) { }

  public toggleMenu = () => {
    this.menuToggle.emit();
  }
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
    DxLoadIndicatorModule,
    DxToolbarModule,
    DxValidatorModule,
    DxPopupModule,
    DxTextBoxModule,
    DxButtonModule,
    DxScrollViewModule,
    DxLoadPanelModule,
    FlexLayoutModule,
    UserPanelModule,
    DxSwitchModule,
    DxContextMenuModule,
  ],
  declarations: [HeaderComponent, TopNavigationMenuComponent, UserProfileComponent, ThemeToggleComponent],
  exports: [HeaderComponent],
})
export class HeaderModule { }
